import React, { Fragment, Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CSSTransition } from 'react-transition-group';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as sectionsActions from '../../redux/actions/sectionsActions';
import * as statusActions from '../../redux/actions/statusActions';

import SoftAlert from '../common/SoftAlert';
import OutroPagination from '../features/assessment/OutroPagination';
import QuestionLongAnswer from '../features/assessment/QuestionLongAnswer';
// import QuestionSlider from '../features/assessment/QuestionSlider';
import getUnansweredQuestions from '../../utils/unansweredQuestions';

class NewAssessmentOutroPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSoftAlert: false,
      serverErrors: [],
    };
  }

  componentDidMount() {
    if (!this.props.assessments[this.props.match.params.assessmentId]) {
      // grab the assessment from the database if necessary
      this.props.assessmentsActions.getAssessment(this.props.match.params.assessmentId, true);
    } else if (this.props.currentAssessment.id !== this.props.match.params.assessmentId) {
      // no need for more from the database, just update the current assessment
      this.props.assessmentsActions.updateCurrentAssessment(this.props.assessments[this.props.match.params.assessmentId]);
    }
  }

  handleInputChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    this.props.assessmentsActions.saveAssessmentInfo({
      [name]: value
    });
  }

  componentWillUnmount() {
    // Reset the current assessment if we navigate away, so that
    // it doesn't interfere with the next assessment we do
    this.props.assessmentsActions.clearCurrentAssessment();
  }

  putAnswer = () => {
    // handle validation here
    console.log('putting')
    this.props.assessmentsActions.putAssessment(this.props.currentAssessment);
  }

  completeAssessment = () => {
    this.props.assessmentsActions.putAssessment(
      this.props.currentAssessment,
      true,
      this.onCompleteAssessmentFailure,
      this.onCompleteAssessmentSuccess,
    );
  }

  onCompleteAssessmentSuccess = () => {
    this.props.history.push(`/assessments/${this.props.currentAssessment.id}/complete`);
  }

  onCompleteAssessmentFailure = (error) => {
    // Override any previous errors' timeouts
    clearTimeout(this.hideSoftAlertTimeout);
    clearTimeout(this.clearSoftAlertDataTimeout);
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
      showSoftAlert: true,
    });
    this.hideSoftAlertTimeout = setTimeout(() => {
      // Begin hiding the alert after 2 seconds
      this.setState({ showSoftAlert: false });
      this.clearSoftAlertDataTimeout = setTimeout(() => {
        // Clear the data after the transition is done
        this.setState({
          serverErrors: [],
        });
      }, 200);
    }, 2000);
  }

  revisitQuestions = () => {
    this.props.statusActions.beginRevisitAssessment(this.props.currentAssessment.id);
    this.props.history.push(`/assessments/${this.props.currentAssessment.id}/${this.unansweredQuestions[0].index + 1}`);
  }

  render() {
    const { serverErrors } = this.state;

    if (this.props.currentAssessment.dateCompleted) {
      // Once the server saves the assessment, redirect away
      return <Redirect to={`/assessments/${this.props.currentAssessment.id}/complete`} />;
    }
    if (!this.props.currentAssessment.section) {
      // If there's some trouble with the current assessment, reset
      return <Redirect to='/assessments/new' />;
    }
    if (!this.props.sections || !this.props.sections[this.props.currentAssessment.section] || !this.props.sections[this.props.currentAssessment.section].questions) {
      // We don't have any sections or we don't have the current section or we don't have the deep version of the current section
      this.props.sectionsActions.getSection(this.props.currentAssessment.section);
      return null;
    }
    const section = this.props.sections[this.props.currentAssessment.section];
    this.unansweredQuestions = getUnansweredQuestions(this.props.sections[this.props.currentAssessment.section].questions, this.props.currentAssessment.answers);
    return (
      <Fragment>
        <Helmet>
          <title>New Assessment</title>
        </Helmet>
        <div className="new-assessment-detail new-assessment-detail--no-sticky-buttons">
          <div className="row">
            <div className={'new-assessment-detail__heading color--' + section.theme}>
              {section.fullTitle}
            </div>
          </div>
          <div className="row">
            <div className="new-assessment-detail__content">
              <h1 className="new-assessment-detail__large-heading">
                Final comments
              </h1>
              <div className="new-assessment-detail__outro-instructions">
                Please take this opportunity to make any notes about the overall state of practices and priorities in your institution.
              </div>
              <div className="form new-assessment-detail__form">
                <div className="new-assessment-detail__part">
                  <QuestionLongAnswer
                    name='notes'
                    questionId='notes'
                    onChange={this.handleInputChange}
                    value={this.props.currentAssessment.notes}
                    label='Notes:'
                  />
                </div>
              </div>
              {!!this.unansweredQuestions.length &&
                <div className="new-assessment-detail__outro-details">
                  <p>
                    There are {this.unansweredQuestions.length} questions that have been left unanswered in this assessment.
                  </p>
                  <p>
                    Please note that after an assessment is submitted below, its answers are no longer editable.
                  </p>
                  <button className="flat-link-from-button" onClick={this.revisitQuestions}>
                    Revisit Unanswered Questions
                  </button>
                </div>
              }
            </div>
            <OutroPagination
              navigate={this.props.history.push}
              putAssessment={this.putAnswer}
            />
            <div className="new-assessment-detail__pagination-wrapper">
              <button
                onClick={this.completeAssessment}
                className="button button--large"
              >
                Submit Assessment
              </button>
            </div>
          </div>
        </div>
        <CSSTransition
          classNames="transition"
          timeout={200}
          in={this.state.showSoftAlert}
          mountOnEnter
          unmountOnExit
        >
          <SoftAlert errors={serverErrors} />
        </CSSTransition>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
    currentAssessment: state.assessments.currentAssessment,
    assessments: state.assessments.list
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    sectionsActions: bindActionCreators(sectionsActions, dispatch),
    statusActions: bindActionCreators(statusActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewAssessmentOutroPage);


// WEBPACK FOOTER //
// ./src/components/pages/NewAssessmentOutroPage.js